(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class MansoryHeroSlider {
    constructor(hero) {
      this.hero = hero;
      this.slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
      this.previousButton = hero.querySelector('[data-hero-previous]');
      this.nextButton = hero.querySelector('[data-hero-next]');
      this.autoplay = hero.dataset.autoplay === 'true';
      this.delay = Number(hero.dataset.autoplayDelay) || 5500;
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.timer = null;
      this.touchStartX = 0;
      this.touchStartY = 0;

      if (this.slides.length <= 1) return;

      this.bindEvents();
      this.goTo(this.currentIndex);

      if (this.autoplay) {
        this.play();
      }
    }

    bindEvents() {
      this.previousButton?.addEventListener('click', () => {
        this.previous();
        this.restart();
      });

      this.nextButton?.addEventListener('click', () => {
        this.next();
        this.restart();
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.heroDot));
          this.restart();
        });
      });

      this.hero.addEventListener('mouseenter', () => this.pause());
      this.hero.addEventListener('mouseleave', () => this.play());

      this.hero.addEventListener(
        'touchstart',
        (event) => {
          this.touchStartX = event.touches[0].clientX;
          this.touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      this.hero.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - this.touchStartX;
          const deltaY = touch.clientY - this.touchStartY;

          if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

          if (deltaX > 0) {
            this.previous();
          } else {
            this.next();
          }

          this.restart();
        },
        { passive: true }
      );

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pause();
        } else {
          this.play();
        }
      });
    }

    goTo(index) {
      const nextIndex = (index + this.slides.length) % this.slides.length;

      this.slides[this.currentIndex]?.classList.remove('is-active');
      this.dots[this.currentIndex]?.classList.remove('is-active');
      this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');

      this.currentIndex = nextIndex;

      this.slides[this.currentIndex]?.classList.add('is-active');
      this.dots[this.currentIndex]?.classList.add('is-active');
      this.dots[this.currentIndex]?.setAttribute('aria-selected', 'true');
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }

    previous() {
      this.goTo(this.currentIndex - 1);
    }

    play() {
      if (!this.autoplay || this.slides.length <= 1 || this.timer) return;

      this.timer = window.setInterval(() => this.next(), this.delay);
    }

    pause() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.pause();
      this.play();
    }
  }

  const initMansoryHeroSliders = () => {
    document.querySelectorAll('[data-hero-slider]').forEach((hero) => {
      if (hero.dataset.sliderInitialized === 'true') return;

      hero.dataset.sliderInitialized = 'true';
      new MansoryHeroSlider(hero);
    });
  };

  initMansoryHeroSliders();

  document.addEventListener('shopify:section:load', initMansoryHeroSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mansory-new-drops"] && !Shopify.designMode) return;
  try {
    
  class MansoryNewDrops {
    constructor(section) {
      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-mnd-tab]'));
      this.panels = Array.from(section.querySelectorAll('[data-mnd-panel]'));

      this.bindTabs();
      this.bindProducts();
    }

    bindTabs() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = Number(tab.dataset.mndTab);
          this.activateTab(index);
        });
      });
    }

    activateTab(index) {
      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;

        if (isActive) {
          panel.hidden = false;
          window.requestAnimationFrame(() => panel.classList.add('is-active'));
        } else {
          panel.classList.remove('is-active');
          window.setTimeout(() => {
            panel.hidden = true;
          }, 300);
        }
      });
    }

    bindProducts() {
      this.section.querySelectorAll('[data-mnd-product]').forEach((productCard) => {
        const sizeButtons = Array.from(productCard.querySelectorAll('[data-mnd-size]'));
        const status = productCard.querySelector('[data-mnd-status]');

        sizeButtons.forEach((button) => {
          button.addEventListener('click', async () => {
            if (button.disabled) return;
            const variantId = button.dataset.mndVariant;
            if (!variantId) return;

            sizeButtons.forEach((b) => b.classList.remove('is-selected'));
            button.classList.add('is-selected');
            button.disabled = true;
            const originalText = button.textContent;
            button.textContent = '...';

            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 })
              });

              if (!response.ok) throw new Error();

              button.textContent = '✓';
              if (status) status.textContent = 'Agregado al carrito';
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:updated'));
            } catch {
              button.textContent = '!';
              if (status) status.textContent = 'No se pudo agregar';
            } finally {
              window.setTimeout(() => {
                button.disabled = false;
                button.textContent = originalText;
                button.classList.remove('is-selected');
                if (status) status.textContent = '';
              }, 1500);
            }
          });
        });
      });
    }
  }

  const initMansoryNewDrops = () => {
    document.querySelectorAll('[data-mansory-new-drops]').forEach((section) => {
      if (section.dataset.mndInitialized === 'true') return;

      section.dataset.mndInitialized = 'true';
      new MansoryNewDrops(section);
    });
  };

  initMansoryNewDrops();

  document.addEventListener('shopify:section:load', initMansoryNewDrops);

  } catch(e) { console.error(e); }
})();
})();
